import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from '../../Common/Tooltip';
// styles
import './style.scss';

/**
 * Metrics container
 * @param {MRB.Response} metricsData
 * @returns {JSX.Element}
 * @constructor
 */

const MetricsContainer = ({ metricsData }) => {
  const Counter = ({ value, label, tooltipmsg }) => (
      <Tooltip message={tooltipmsg} classParent="MetricsContainer__counter_tool-tip" className="Tooltip_Blue Tooltip_Top">
        <div className="MetricsContainer__counter">
          <label>{value}</label>
          <div>{label}</div>
        </div>
      </Tooltip>
    
  );

  return (
    <div className="MetricsContainer">
      <Counter value={metricsData?.results?.turn_days_gt_5 || 0} label="TURN >5 DAYS"  tooltipmsg="The total number of Unit Workflows designated as unit turn with a Unit Turn Time greater than five days."/>
      <Counter value={metricsData?.results?.overdue_unit_count || 0} label="OVERDUE UNITS" tooltipmsg="The total number of units at a property where a Unit Workflow has been triggered and the due date of the last task is before the current date."/>
      <Counter value={metricsData?.results?.avg_turn_days.toFixed(2) || 0} label="AVG. TURN DAYS" tooltipmsg="The average unit turn days for all units at a property for Workflows designated as unit turn." />
      <Counter value={metricsData?.results?.units_on_notice_count || 0} label="UNITS ON NOTICE" tooltipmsg="The total number of units at a property where a Move out workflow has been triggered but not yet completed." />
    </div>
  );
};

MetricsContainer.propTypes = {
  metricsData: PropTypes.object
};

export default MetricsContainer;
